import { render, staticRenderFns } from "./ChildActivityConfigListPage.vue?vue&type=template&id=087960af&scoped=true"
import script from "./ChildActivityConfigListPage.vue?vue&type=script&lang=js"
export * from "./ChildActivityConfigListPage.vue?vue&type=script&lang=js"
import style0 from "./ChildActivityConfigListPage.vue?vue&type=style&index=0&id=087960af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087960af",
  null
  
)

export default component.exports